import React from 'react';
import emaarLogo from '@/assets/images/emaar-logo.svg';

interface BadeelLogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  className?: string;
}

export function BadeelLogo({ size = 'md', showText = true, className = '' }: BadeelLogoProps) {
  const sizeClasses = {
    sm: 'h-8',
    md: 'h-10',
    lg: 'h-12'
  };

  return (
    <div className={`flex items-center ${className}`}>
      <img
        src={emaarLogo}
        alt="Emaar Platform Logo"
        className={`${sizeClasses[size]} w-auto object-contain`}
      />
    </div>
  );
}
